import {
    GET_ROLE,
    GET_ROLE_FAIL,
    GET_ROLE_SUCCESS,
    GET_ROLE_DETAILS,
    GET_ROLE_DETAILS_FAIL,
    GET_ROLE_DETAILS_SUCCESS,
    ADD_NEW_ROLE,
    ADD_ROLE_SUCCESS,
    ADD_ROLE_FAIL,
    UPDATE_ROLE,
    UPDATE_ROLE_SUCCESS,
    UPDATE_ROLE_FAIL,
    DELETE_ROLE,
    DELETE_ROLE_SUCCESS,
    DELETE_ROLE_FAIL,
    GET_PERMISSION,
    GET_PERMISSION_FAIL,
    GET_PERMISSION_SUCCESS,
    RESET_ROLE_STATE
  } from "./actionTypes";
  
  export const getRole = ({length, sort, page, sort_by}) => ({
    type: GET_ROLE,
    payload: {length, sort, page, sort_by},
  });
  
  export const getRoleSuccess = role => ({
    type: GET_ROLE_SUCCESS,
    payload: role,
  });
  
  export const getRoleFail = error => ({
    type: GET_ROLE_FAIL,
    payload: error,
  });

  export const getRoleDetails = ({id}) => ({
    type: GET_ROLE_DETAILS,
    payload: {id},
  });
  
  export const getRoleDetailsSuccess = role => ({
    type: GET_ROLE_DETAILS_SUCCESS,
    payload: role,
  });
  
  export const getRoleDetailsFail = error => ({
    type: GET_ROLE_DETAILS_FAIL,
    payload: error,
  });
  
  //add 
  export const addNewRole = role => ({
    type: ADD_NEW_ROLE,
    payload: role,
  });
  
  export const addRoleSuccess = role => ({
    type: ADD_ROLE_SUCCESS,
    payload: role,
  });
  
  export const addRoleFail = error => ({
    type: ADD_ROLE_FAIL,
    payload: error,
  });
  
  //update 
  export const updateRole =({id, role}) => ({
    type: UPDATE_ROLE,
    payload:{id, role},
  });
  
  export const updateRoleSuccess = role => ({
    type: UPDATE_ROLE_SUCCESS,
    payload: role,
  });
  
  export const updateRoleFail = error => ({
    type: UPDATE_ROLE_FAIL,
    payload: error,
  });
  
  //delete 
  export const deleteRole =({id}) => ({
    type: DELETE_ROLE,
    payload:{id},
  });
  
  export const deleteRoleSuccess = role => ({
    type: DELETE_ROLE_SUCCESS,
    payload: role,
  });
  
  export const deleteRoleFail = error => ({
    type: DELETE_ROLE_FAIL,
    payload: error,
  });

  //permission
  export const getPermission = ({length, page, sort}) => ({
    type: GET_PERMISSION,
    payload: {length, page, sort},
  });
  
  export const getPermissionSuccess = role => ({
    type: GET_PERMISSION_SUCCESS,
    payload: role,
  });
  
  export const getPermissionFail = error => ({
    type: GET_PERMISSION_FAIL,
    payload: error,
  });
  
  //reset
  export const resetRoleState = () => {
    return {
        type: RESET_ROLE_STATE,
    }
  }
  
  